import { render, staticRenderFns } from "./PackagingSlide.vue?vue&type=template&id=6bcc6c07&scoped=true&"
import script from "./PackagingSlide.vue?vue&type=script&lang=js&"
export * from "./PackagingSlide.vue?vue&type=script&lang=js&"
import style0 from "./PackagingSlide.vue?vue&type=style&index=0&id=6bcc6c07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc6c07",
  null
  
)

export default component.exports